import React from 'react';

class ItemListHeading extends React.Component {
  render() {
    const { tanTable = false } = this.props;
    const { fieldTitle } = this.props.field;
    if (tanTable) {
      return fieldTitle.en;
    }
    return <th>{fieldTitle.en}</th>;
  }
}

export default ItemListHeading;
